import React from "react";

const FilterIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.66663 4C2.66663 2.89543 3.56206 2 4.66663 2H11.3333C12.4379 2 13.3333 2.89543 13.3333 4V4.73952C13.3333 5.30649 13.0926 5.84682 12.6712 6.2261L9.99996 8.63024V12.2546C9.99996 12.7597 9.71462 13.2214 9.26291 13.4472L7.92958 14.1139C7.04304 14.5571 5.99996 13.9125 5.99996 12.9213V8.63024L3.3287 6.22611C2.90727 5.84682 2.66663 5.30649 2.66663 4.73952V4ZM4.66663 3.33333C4.29844 3.33333 3.99996 3.63181 3.99996 4V4.73952C3.99996 4.92851 4.08017 5.10862 4.22065 5.23505L6.89191 7.63918C7.17286 7.89204 7.33329 8.25226 7.33329 8.63024V12.9213L8.66663 12.2546V8.63024C8.66663 8.25226 8.82705 7.89204 9.10801 7.63918L11.7793 5.23505C11.9197 5.10862 12 4.92851 12 4.73952V4C12 3.63181 11.7015 3.33333 11.3333 3.33333H4.66663Z"
        fill="#070B12"
      />
    </svg>
  );
};

export default FilterIcon;
